import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import PageHero from '../Elements/PageHero';
import Contact from '../Elements/Contact';
import usePageMeta from '../../hooks/usePageMeta';
import { services } from '../../content/site';
import { ArrowRight } from '../Common/Icons';

import bg from '../../images/main-slider/slider2/slide2.jpg';

const Error = () => {
  usePageMeta({
    title: 'Page not found | LIDA Engineering',
    description: 'The page you are looking for is not here.',
  });

  return (
    <>
      <Header overHero />
      <main id="main" className="page-content">
        <PageHero
          title="Page not found"
          lead="The page you are looking for is not here. Try one of the links below."
          image={bg}
        />

        <section className="section">
          <div className="container container--narrow">
            <p className="eyebrow">Error 404</p>
            <h2>Let’s get you back on track.</h2>

            <div style={{ display: 'grid', gap: 'var(--s-4)', marginTop: 'var(--s-7)' }}>
              <Link to="/" className="btn" style={{ justifySelf: 'start' }}>
                Back to home
                <ArrowRight />
              </Link>

              <ul style={{ display: 'grid', gap: 'var(--s-3)', marginTop: 'var(--s-4)' }}>
                {services.map((service) => (
                  <li key={service.id}>
                    <Link to={service.link} className="link-arrow">
                      {service.title}
                      <ArrowRight size={15} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Error;
